import { keyframes, styled } from "@mui/material/styles";

/* Page */
export const Page = styled("div")(() => ({
  minHeight: "100vh",
  backgroundColor: "#f1f5f9",
}));

/* Header */
export const Header = styled("header")(() => ({
  height: 64,
  backgroundColor: "#0f172a",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  padding: "0 24px",
}));

export const Logo = styled("img")(() => ({
  height: 36,
  marginRight: 12,
}));

export const AuthBox = styled("div")(() => ({
  marginLeft: "auto",
  display: "flex",
  alignItems: "center",
}));

/* Google button container */
export const GoogleButton = styled("div")(() => ({
  cursor: "pointer",
}));

export const UserName = styled("span")(() => ({
  marginLeft: 8,
  fontSize: 14,
  fontWeight: 500,
}));

export const Avatar = styled("img")(() => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
}));

/* Main content */
export const Main = styled("main")(() => ({
  maxWidth: 768,
  margin: "40px auto",
  backgroundColor: "#fff",
  borderRadius: 16,
  padding: 32,
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
}));

export const Title = styled("h1")(() => ({
  fontSize: 24,
  fontWeight: 600,
  marginBottom: 24,
}));

/* Form */
export const FormGroup = styled("div")(() => ({
  marginBottom: 24,
}));

export const Label = styled("label")(() => ({
  fontWeight: 500,
  marginBottom: 8,
  display: "block",
}));

export const Input = styled("input")(() => ({
  width: "100%",
  padding: 12,
  borderRadius: 8,
  border: "1px solid #cbd5e1",
  fontSize: 14,
}));

export const Select = styled("select")(() => ({
  width: "100%",
  padding: 12,
  borderRadius: 8,
  border: "1px solid #cbd5e1",
  fontSize: 14,
}));

export const Note = styled("p")(() => ({
  fontSize: 16,
  color: "#64748b",
  marginTop: 24,
  padding: "20px 32px",
  background: "linear-gradient(135deg, #f3e7ff 0%, #ffffff 50%, #e0f2ff 100%)",
  borderRadius: "8px",
}));

/* Language row */
export const LanguageRow = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "1fr 40px 1fr",
  gap: 12,
  alignItems: "center",
}));

export const Arrow = styled("div")(() => ({
  textAlign: "center",
  fontSize: 20,
}));

/* Button */
export const Button = styled("button")(() => ({
  width: "100%",
  padding: "14px 0",
  backgroundColor: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 12,
  fontSize: 16,
  cursor: "pointer",
  transition: "background-color 0.2s",
  "&:hover": {
    backgroundColor: "#1d4ed8",
  },
  "&:disabled": {
    backgroundColor: "#f0f0f0ff",
    color: "#8b8484ff",
    borderColor:
      "light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3))",
  },
}));

export const slideDown = keyframes({
  from: {
    opacity: 0,
    transform: "translateY(-8px) scale(0.98)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0) scale(1)",
  },
});

/* User menu */
export const UserMenuWrapper = styled("div")(() => ({
  position: "relative",
}));

export const UserTrigger = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
}));

export const DropdownMenu = styled("div")(() => ({
  position: "absolute",
  right: 0,
  top: "calc(100% + 8px)",
  minWidth: 180,

  backgroundColor: "#fff",
  borderRadius: 12,
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  padding: "6px 0",

  animation: `${slideDown} 0.18s ease-out`,
  zIndex: 20,
}));

export const DropdownItem = styled("div")(() => ({
  padding: "10px 16px",
  fontSize: 14,
  cursor: "pointer",
  transition: "background-color 0.15s",
  color: "#000000",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
}));

export const DropdownItemLogout = styled("div")(() => ({
  padding: "10px 16px",
  fontSize: 14,
  cursor: "pointer",
  color: "#e53935",
  fontWeight: 500,
  transition: "background-color 0.15s",

  "&:hover": {
    backgroundColor: "#fee2e2",
  },
}));

/* Upload */
export const UploadBox = styled("label")(() => ({
  border: "2px dashed #c7d2fe",
  borderRadius: 16,
  padding: "28px 20px",
  textAlign: "center",
  cursor: "pointer",
  backgroundColor: "#f8fafc",
  transition: "all 0.2s ease",
  display: "block",
  "&:hover": {
    borderColor: "#2563eb",
    backgroundColor: "#eef2ff",
  },
}));

export const UploadIcon = styled("div")(() => ({
  width: "64px",
  height: "64px",
  background: "#f3e7ff",
  borderRadius: "50%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "1rem",
}));

export const UploadSvg = styled("svg")(() => ({
  width: "32px",
  height: "32px",
  color: "#9333ea",
}));

export const UploadText = styled("div")(() => ({
  fontSize: 15,
  fontWeight: 500,
  color: "#1e293b",
}));

export const UploadHint = styled("div")(() => ({
  marginTop: 6,
  fontSize: 13,
  color: "#64748b",
}));

export const HiddenInput = styled("input")(() => ({
  display: "none",
}));

export const FilePreview = styled("div")(() => ({
  marginTop: 12,
  fontSize: 14,
  color: "#2563eb",
  fontWeight: 500,
}));

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled("div")(() => ({
  width: 20,
  height: 20,
  border: "3px solid rgba(255,255,255,0.3)",
  borderTop: "3px solid #ffffff",
  borderRadius: "50%",
  animation: `${spin} 0.8s linear infinite`,
}));

const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const LoadingText = styled("span")(() => ({
  marginLeft: 10,
  fontSize: 14,
  fontWeight: 500,
  animation: `${pulse} 1.2s ease-in-out infinite`,
}));

export const LoadingButtonContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const LoadingOverlay = styled("div")(() => ({
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  backdropFilter: "blur(4px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
}));

export const WaveProgressWrapper = styled("div")(() => ({
  marginTop: 16,
}));

export const WaveTitle = styled("div")(() => ({
  fontSize: 14,
  marginBottom: 6,
}));

export const WaveProgress = styled("div")(() => ({
  position: "relative",
  height: 12,
  width: "100%",
  backgroundColor: "#e5e7eb",
  borderRadius: 999,
  overflow: "hidden",
}));

export const WaveProgressFill = styled("div")<{ done?: boolean }>(
  ({ done }) => ({
    height: "100%",
    borderRadius: 999,
    background: `
      repeating-linear-gradient(
        135deg,
        #4f46e5 0px,
        #4f46e5 10px,
        #6366f1 10px,
        #6366f1 20px,
        #818cf8 20px,
        #818cf8 30px
      )
    `,
    backgroundSize: "200% 100%",
    //animation: done ? "none" : "waveStripe 4.2s linear infinite",

    transition: "none", // 👈 rất quan trọng

    boxShadow: "0 0 6px rgba(99,102,241,0.6)",

    "@keyframes waveStripe": {
      "0%": { backgroundPosition: "200% 0" },
      "100%": { backgroundPosition: "-200% 0" },
    },
  }),
);

export const WavePercent = styled("div")(() => ({
  marginTop: 6,
  fontSize: 12,
  color: "#475569",
}));

export const PreviewOverlay = styled("div")(() => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1300,
}));

export const PreviewModal = styled("div")(() => ({
  width: "90%",
  maxWidth: 900,
  backgroundColor: "#ffffff",
  borderRadius: 16,
  padding: 20,
  boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
  display: "flex",
  flexDirection: "column",
}));

export const PreviewHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBottom: 12,
  borderBottom: "1px solid #e5e7eb",
}));
export const PreviewTitle = styled("h3")(() => ({
  margin: 0,
  fontSize: 18,
}));
export const CloseButton = styled("button")(() => ({
  border: "none",
  background: "transparent",
  fontSize: 20,
  cursor: "pointer",
  lineHeight: 1,
}));
export const PreviewContent = styled("div")(() => ({
  marginTop: 16,
  maxHeight: "65vh",
  overflow: "auto",
  backgroundColor: "#f8fafc",
  padding: 16,
  borderRadius: 8,
}));
export const PreviewCanvas = styled("canvas")(() => ({
  width: "100%",
  backgroundColor: "#ffffff",
  borderRadius: 8,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
}));
export const PreviewFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 16,
  gap: 8,
}));

export const ButtonSaveFileModal = styled("button")(() => ({
  width: "fixContent",
  padding: "14px 32px",
  backgroundColor: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 12,
  fontSize: 14,
  cursor: "pointer",
  transition: "background-color 0.2s",
  "&:hover": {
    backgroundColor: "#1d4ed8",
  },
  "&:disabled": {
    backgroundColor: "#f0f0f0ff",
    color: "#8b8484ff",
    borderColor:
      "light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3))",
  },
}));

export const ButtonCloseModal = styled("button")(() => ({
  width: "fixContent",
  padding: "14px 32px",
  backgroundColor: "red",
  color: "#fff",
  border: "none",
  borderRadius: 12,
  fontSize: 14,
  cursor: "pointer",
  transition: "background-color 0.2s",

  "&:disabled": {
    backgroundColor: "#f0f0f0ff",
    color: "#8b8484ff",
    borderColor:
      "light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3))",
  },
}));
